module.exports = __webpack_public_path__ + "img/dashboard.e89f3b05.png";